import { useUserStore as useCanonicalUserStore } from '@/modules/user/stores/users.store';

export const useUserStore = ((
  ...args: Parameters<typeof useCanonicalUserStore>
) => {
  return useCanonicalUserStore(...args);
}) as typeof useCanonicalUserStore;
